import React from "react";

import type { SyntheticListenerMap } from "@dnd-kit/core/dist/hooks/utilities";

interface RowContextProps {
    setActivatorNodeRef?: (element: HTMLElement | null) => void;
    listeners?: SyntheticListenerMap;
}

export const RowContext = React.createContext<RowContextProps>({});
export type { RowContextProps };
